import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextEmitCreditNote } from "..";

export default function SocialReason() {
  const hook = useContext(ContextEmitCreditNote);

  return (
    <div>
      <Label required={hook.invoice === undefined}>Razón social</Label>
      <p>
        {hook.invoice === undefined
          ? "Primero selecciona una factura"
          : hook.invoice.socialReason}
      </p>
    </div>
  );
}
